import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([actions.COMMENTS_FETCH_SUCCESS], 'commentsIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/byQuery/byPage/reducer.js
 **/